import { FormControl, FormLabel, FormLabelProps } from "@chakra-ui/react";
import React from "react";
import {
  Controller,
  ControllerProps,
  ControllerRenderProps,
  FieldPath,
  FieldValues,
} from "react-hook-form";

type FieldControllerRenderProps<T extends FieldValues, K extends FieldPath<T>> = {
  field: ControllerRenderProps<T, K>;
  labelProps?: FormLabelProps;
  label: string | React.ReactNode;
};

type FieldControllerProps<T extends FieldValues, K extends FieldPath<T>> = ControllerProps<T, K> & {
  render: (props: FieldControllerRenderProps<T, K>) => React.ReactNode;
  label?: string | React.ReactNode;
  labelProps?: FormLabelProps;
  isRequired?: boolean;
  hideRequiredAstrisk?: boolean;
};

export function FieldController<T extends FieldValues, K extends FieldPath<T>>({
  render,
  isRequired,
  hideRequiredAstrisk,
  ...props
}: FieldControllerProps<T, K>) {
  isRequired =
    typeof props.rules?.required === "string" ? true : !!props.rules?.required || isRequired;

  const labelProps = {
    fontSize: "lg",
    ...props.labelProps,
  };
  return (
    <Controller
      {...props}
      render={(fieldProps) => {
        return (
          <FormControl isRequired={isRequired && !hideRequiredAstrisk}>
            {props.label && <FormLabel {...labelProps}>{props.label}</FormLabel>}
            {render(fieldProps)}
          </FormControl>
        );
      }}
    />
  );
}
